import React, { useEffect, useState } from "react";
import { ReactComponent as DownArrow } from "../assets/icons/downArrow.svg";
import { ReactComponent as Logout } from "../assets/icons/logout.svg";
import { ReactComponent as Account } from "../assets/icons/account.svg";
import { ReactComponent as Hat } from "../assets/icons/hat.svg";
import { ReactComponent as Home } from "../assets/icons/home.svg";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import { useDispatch, useSelector } from "react-redux";
import { thisUserActions } from "../utils/store/thisUser";
import { thisTutorActions } from "../utils/store/thisTutor";

function Navbar({ user }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let pathname = useLocation().pathname;
  const thisTutor = useSelector((state) => state.thisTutor.thisTutor);
  const thisUser = useSelector((state) => state.thisUser.user);
  const [showDropdown, setShowDropDown] = useState(false);
  const [profileImg, setProfileImg] = useState(
    "https://pbs.twimg.com/profile_images/716487122224439296/HWPluyjs_400x400.jpg"
  );

  const logoutHandler = async () => {
    const auth = getAuth();
    await signOut(auth)
      .then(() => {
        // SG 08/09/2022 00:33 clearning data
        dispatch(thisUserActions.set(null));
        dispatch(thisTutorActions.set(null));
      })
      .catch((e) => console.log(e));
    navigate("/login");
  };

  const fetchProfileImg = async () => {
    const docRef = doc(db, "users", user.uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setProfileImg(docSnap.data().picturePath);
    } else {
      console.log("No document found");
    }
  };

  useEffect(() => {
    if (user) {
      const fetchData = async () => {
        await fetchProfileImg();
      };
      fetchData();
    }
  }, [user]);

  useEffect(() => {
    if (user && document.getElementById("navbar-profile-dropdown")) {
      var dropdown = document.getElementById("home-dropdown");
      if (dropdown) {
        document.addEventListener("click", (event) => {
          var isClickInsideElement = dropdown.contains(event.target);
          let menu = document
            .getElementById("navbar-profile-dropdown")
            .contains(event.target);
          if (!isClickInsideElement && !menu) {
            setShowDropDown(false);
          }
        });
      }
    }
  }, [showDropdown]);

  return (
    <div className="flex justify-between p-4" id="navbar-top">
      <p
        className="text-xl font-semibold text-gray-800 cursor-pointer"
        onClick={() => navigate("/")}
      >
        Kuwait CU
      </p>
      {user ? (
        <div className="flex flex-col relative">
          <div
            id="home-dropdown"
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => setShowDropDown(!showDropdown)}
          >
            <DownArrow
              className={`${
                showDropdown ? "rotate-180" : "rotate-0"
              }  transition duration-200 ease-in-out w-5`}
            />
            <img
              className="h-10 w-10 rounded-full border-[2px] object-cover"
              src={thisTutor ? thisTutor?.profileImagePath : profileImg}
            />
          </div>
          <div
            className={`absolute border-[0.1px] top-[2.8em] z-30 right-0 bg-white shadow-md rounded-lg w-[11em] flex justify-center flex-col items-center transition duration-200 ease-in-out ${
              showDropdown ? "scale-100" : "scale-0 -translate-y-[50%]"
            }`}
            id="navbar-profile-dropdown"
          >
            <div className="border-b-[1px] w-full flex justify-center items-center p-3">
              <p className="font-semibold">
                {thisTutor
                  ? `${thisTutor?.firstName} ${thisTutor?.lastName}`
                  : `${thisUser?.firstName} ${thisUser?.lastName}`}
              </p>
              {thisTutor && (
                <Hat width="25" height="25" className="ml-3 mt-[.05em]" />
              )}
            </div>

            <div className="p-3 w-full border-b-[1px]">
              {thisTutor && (
                <Link
                  state={{ cameFrom: pathname }}
                  to="/my-profile"
                  className="bg-gray-100 px-4 py-3 rounded-lg flex justify-between cursor-pointer hover:bg-gray-200 mb-2"
                  onClick={() => {
                    setShowDropDown(false);
                    navigate("/my-profile", {
                      state: { id: 7, color: "green" },
                    });
                  }}
                >
                  <Account className="text-gray-800" />
                  <p className="text-gray-800 font-medium">Edit profile</p>
                </Link>
              )}
              <div
                className="bg-gray-100 px-4 py-3 rounded-lg flex cursor-pointer hover:bg-gray-200"
                onClick={() => {
                  setShowDropDown(false);
                  navigate("/");
                }}
              >
                <Home className="text-gray-800" />
                <p className="text-gray-800 font-medium text-center flex-1">
                  Home
                </p>
              </div>
            </div>

            <div
              className="flex items-center w-full py-3 px-6 group cursor-pointer"
              onClick={logoutHandler}
            >
              <Logout className="text-red-400 mr-3 group-hover:translate-x-[3.2em] transition duration-200 ease-in-out" />
              <p className="font-medium cursor-pointer text-red-400 group-hover:hidden">
                Logout
              </p>
            </div>
          </div>
        </div>
      ) : (
        <button
          className="font-semibold text-gray-600 cursor-pointer mr-5"
          onClick={() => navigate("/login")}
        >
          Log in
        </button>
      )}
    </div>
  );
}

export default Navbar;
